var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
export function getNPCs() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/npcs');
    });
}
export function getNPCById(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/npcs/${id}`);
    });
}
export function createNPC(npcData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post('/npcs', npcData);
    });
}
export function updateNPC(id, npcData) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/npcs/${id}`, npcData);
    });
}
// Delete an NPC (archive it)
export function deleteNPC(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/npcs/${id}`);
    });
}
export function restoreNPC(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/npcs/${id}/restore`);
    });
}
export function deleteNPCPermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/npcs/${id}/permanent`);
    });
}
